<template>
    <div class="container-fluid">
        <!-- breadbrumb -->
        <app-breadcrumb pageTitle="Shoppers" subTitle="Shopper Records"></app-breadcrumb>

        <!-- shopper info -->
        <div v-if="theShopper" class="row my-2">
            <div class="col-md-12 col-12">
                <div class="d-inline-flex">
                    <div class="mr-2">
                        <img v-if="theShopper.dp" :src="myProfilePhoto(theShopper.dp)" 
                        class="message-user-photo rounded-circle img-thumbnail">
                        <i v-else class="far fa-user-circle fa-3x"></i>
                    </div>
                    <p class="m-0">
                        <span class="text-dark text-capitalize font-weight-bold">
                            {{theShopper.name}}'s Record
                        </span><br>
                        <router-link :to="{ name: 'lookup-handle', params: { handle: theShopper.handle} }" class="text-dark-green">
                            @{{theShopper.handle}}
                        </router-link>
                    </p>
                </div>
            </div>
        </div>
        <!-- shopper records -->
        <div v-if="theShopper" class="row">
            <div class="col-12">
                <table class="table table-striped mt-2">
                    <thead class="bg-silver">
                        <tr>
                            <th>S/N</th>
                            <th>Item</th>
                            <th>Time</th>
                            <th>Qty</th>
                            <th class="text-right">Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, i) in theShopperItems" :key="i">
                            <td>{{i+1}}.</td>
                            <td>
                                <router-link :to="{ name: 'listItem', params: { id: item.id } }" class="d-block">
                                    {{item.title | capitalize}} <i class="far fa-share-square text-dark-green"></i>
                                </router-link>
                            </td>
                            <td>{{item.soldTime | moment("MMM D 'YY hh:mm A")}}</td>
                            <td>{{item.quantity}}</td>
                            <td class="text-uppercase text-right text-dark-green">{{item.currency}} {{item.price | money}}</td>
                        </tr>
                        <tr>
                            <th>#</th>
                            <td colspan="3">
                                Total 
                            </td>
                            <td class="text-right h4">
                                <span class="text-uppercase">{{user.currency}}</span> {{totalPrice | money}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { appendImgHostUrl } from '@/store/dry'

import Breadcrumb from '../../shared/Breadcrumb.vue'
import LayoutShop from '@/layouts/Shop.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
    name: "Shoppers",
    data() {
        return {
            totalPrice: 0
        }
    },
    methods: {
        ...mapActions(['fetchShopperRecords']),
        myProfilePhoto(path) {
            if(!path) return ''
            return appendImgHostUrl(path)
        },
        runFetchShopperRecords(buyerId) {
            let shopperObj = {
                sellerId: this.user._id,
                buyerId: buyerId,
            }
            this.fetchShopperRecords(shopperObj).then(() => {}).catch((e) => {})
        }
    },
    computed: {
        ...mapGetters(['shopperRecords', 'user']),
        theShopper() {
            if(this.shopperRecords && this.shopperRecords !== null){
                return this.shopperRecords
            }
            return false
        },
        theShopperItems() {
            if(this.theShopper && this.theShopper.items.length){
                let sumPrices = 0
                for(let x=0; x < this.theShopper.items.length; x++){
                    sumPrices += this.theShopper.items[x].price
                }
                this.totalPrice = sumPrices
                return this.theShopper.items
            }
            return false
        }
    },
    watch: {
        $route() {
            this.runFetchShopperRecords(this.$route.params.id)
        }
    },
    components: {
        appBreadcrumb: Breadcrumb
    },
    created() {
        this.runFetchShopperRecords(this.$route.params.id) 
        this.$emit('update:layout', LayoutShop);
    }
}
</script>